import React from 'react';
import { archiveFileToFile, fileReaderDataUrl, fileReaderText } from '@isyc-react/archives/utils';
import { injectStyle } from '@isyc-react/design/utils';
import { LookAndFeelFileUnloggedStatus } from './look-and-feel-unlogged.vm';
import { LookAndFeelUnloggedError, LookAndFeelUnloggedLoading, } from './look-and-feel-unlogged-base.component';
import { LookAndFeelUnloggedContext } from './look-and-feel-unlogged.context';
import axios from 'axios';
import { useBuCode } from 'common/utils';
const validCssFormats = ['text/css', 'text/plain'];
const validLogoFormats = ['image/png', 'image/jfif', 'image/jpeg', 'image/pjpeg', 'image/webp', 'image/svg+xml'];
const cssInjectionId = 'bu-look-and-feel';
/**
 * @deprecated: Quitar este y usar el de oncustomer
 */
export const LookAndFeelUnloggedProvider = props => {
    const { children, businessUnitCode, components } = props;
    const { Error = LookAndFeelUnloggedError, Loading = LookAndFeelUnloggedLoading } = components !== null && components !== void 0 ? components : {};
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [refresh, setRefresh] = React.useState(true);
    const [cssText, setCssText] = React.useState(null);
    const [cssFileStatus, setCssFileStatus] = React.useState(LookAndFeelFileUnloggedStatus.LOADING);
    const [logoDataUrl, setLogoDataUrl] = React.useState(null);
    const [logoFileStatus, setLogoFileStatus] = React.useState(LookAndFeelFileUnloggedStatus.LOADING);
    const bu = useBuCode();
    const buCode = businessUnitCode ? businessUnitCode : bu;
    const injectCssFileText = React.useCallback((text) => {
        injectStyle(cssInjectionId, text);
    }, []);
    const cleanCssInjection = React.useCallback(() => {
        injectStyle(cssInjectionId);
    }, []);
    React.useEffect(() => {
        if (refresh) {
            setError(false);
            setLoading(true);
            cleanCssInjection();
            axios
                .get(`/api/public/businessUnit/lookAndFeel/${buCode}`)
                .then(res => {
                if (res.data) {
                    const cssArchiveFile = res.data.portalCssArchive;
                    const logoArchiveFile = res.data.portalLogoArchive;
                    if (cssArchiveFile && validCssFormats.includes(cssArchiveFile.format)) {
                        const cssFile = archiveFileToFile(cssArchiveFile);
                        fileReaderText(cssFile)
                            .then(text => {
                            injectCssFileText(text);
                            setCssText(text);
                            setCssFileStatus(LookAndFeelFileUnloggedStatus.READY);
                        })
                            .catch(() => {
                            console.error('[Look and feel]: Parse read theme error');
                            setCssFileStatus(LookAndFeelFileUnloggedStatus.PARSE_READ_ERROR);
                        });
                    }
                    else
                        setCssFileStatus(LookAndFeelFileUnloggedStatus.NOT_PROVIDED);
                    if (logoArchiveFile && validLogoFormats.includes(logoArchiveFile.format)) {
                        const logoFile = archiveFileToFile(logoArchiveFile);
                        fileReaderDataUrl(logoFile)
                            .then(dataUrl => {
                            setLogoDataUrl(dataUrl);
                            setLogoFileStatus(LookAndFeelFileUnloggedStatus.READY);
                        })
                            .catch(() => {
                            console.error('[Look and feel]: Parse read logo error');
                            setLogoFileStatus(LookAndFeelFileUnloggedStatus.PARSE_READ_ERROR);
                        });
                    }
                    else
                        setLogoFileStatus(LookAndFeelFileUnloggedStatus.NOT_PROVIDED);
                }
                else {
                    setCssFileStatus(LookAndFeelFileUnloggedStatus.NOT_PROVIDED);
                    setLogoFileStatus(LookAndFeelFileUnloggedStatus.NOT_PROVIDED);
                }
                setLoading(false);
                setRefresh(false);
            })
                .catch(err => {
                setCssFileStatus(LookAndFeelFileUnloggedStatus.NOT_PROVIDED);
                setLogoFileStatus(LookAndFeelFileUnloggedStatus.NOT_PROVIDED);
                // setError(true)
                setLoading(false);
                setRefresh(false);
            });
        }
    }, [refresh]);
    React.useEffect(() => {
        return () => {
            cleanCssInjection();
        };
    }, []);
    const refetch = React.useCallback(() => {
        if (!refresh) {
            setRefresh(true);
        }
    }, [setRefresh]);
    return (React.createElement(LookAndFeelUnloggedContext.Provider, { value: {
            cssText,
            cssFileStatus,
            setCssText,
            setCssFileStatus,
            logoDataUrl,
            logoFileStatus,
            setLogoDataUrl,
            setLogoFileStatus,
            refresh: refetch,
        } }, loading ? (React.createElement(Loading, null)) : (React.createElement(React.Fragment, null, error ? (React.createElement(Error, { error: 'query', children: children })) : (React.createElement(React.Fragment, null, cssFileStatus === LookAndFeelFileUnloggedStatus.LOADING ? (React.createElement(Loading, null)) : (React.createElement(React.Fragment, null, cssFileStatus === LookAndFeelFileUnloggedStatus.PARSE_READ_ERROR ? (React.createElement(Error, { error: 'parse', children: children })) : (React.createElement(React.Fragment, null, children))))))))));
};
